import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap'
import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import map from 'lodash/map'
import { processDataCollection } from '../actions/application.js'

class DataCollectionsAnalysisToolContainer extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(datacollection) {
    this.props.processDataCollection(datacollection)
  }

  getToolDescription(tool, properties) {
    let description = '[' + tool + ']'
    for (let i = 0; i < properties.length; i++) {
      description =
        description +
        '_' +
        properties[i].dataCollectionNumber +
        '_' +
        properties[i].imagePrefix +
        '_(_' +
        properties[i].numberOfImages +
        '_images),'
    }
    return description
  }

  render() {
    const _this = this
    const ids = map(this.props.datacollections, 'dataCollectionId')

    if (this.props.configuration.dataAnalysis.enabled) {
      if (this.props.jobs.datacollectionJobTypes) {
        const properties = map(this.props.datacollections, function (e) {
          return {
            imagePrefix: e.imagePrefix,
            dataCollectionNumber: e.dataCollectionNumber,
            numberOfImages: e.numberOfImages,
          }
        })
        return (
          <ButtonToolbar>
            {Object.keys(this.props.jobs.datacollectionsJobTypes).map(function (key) {
              return (
                // FIXME bmo 20210210
                // eslint-disable-next-line react/jsx-key
                <ButtonGroup>
                  <Link
                    disabled
                    target="_blank"
                    to={
                      '/analysis/' +
                      key +
                      '?datacollectionids=' +
                      ids +
                      '&description=' +
                      _this.getToolDescription('Merge', properties)
                    }
                  >
                    <Button onClick={() => _this.handleClick(_this.props.datacollection)} bsStyle="primary">
                      {key}
                    </Button>
                  </Link>
                </ButtonGroup>
              )
            })}
          </ButtonToolbar>
        )
      }
    }
    return null
  }
}

function mapStateToProps(state) {
  return {
    jobs: state.jobs,
    configuration: state.configuration,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    processDataCollection: dataCollection => dispatch(processDataCollection(dataCollection)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataCollectionsAnalysisToolContainer)
